export const START_FETCH_HABITS = 'features/Request/FETCH_HABITS';
export const ERROR_FETCH_HABITS = 'features/Request/ERROR_FETCH_HABITS';
export const DONE_FETCH_HABITS = 'features/Request/DONE_FETCH_HABITS';

export const START_FETCH_CHECKLISTS = 'features/Request/START_FETCH_CHECKLISTS';
export const ERROR_FETCH_CHECKLISTS = 'features/Request/ERROR_FETCH_CHECKLIST';
export const DONE_FETCH_CHECKLISTS = 'features/Request/DONE_FETCH_CHECKLIST';

export const START_SAVING_HABIT = 'features/Request/START_SAVING_HABIT';
export const ERROR_SAVING_HABIT = 'features/Request/ERROR_SAVING_HABIT';
export const DONE_SAVING_HABIT = 'features/Request/DONE_SAVING_HABIT';

export const START_MARKING_COMPLETE = 'features/Request/START_MARKING_COMPLETE';
export const ERROR_MARKING_COMPLETE = 'features/Request/ERROR_MARKING_COMPLETE';
export const DONE_MARKING_COMPLETE = 'features/Request/DONE_MARKING_COMPLETE';

export const START_UNDO_COMPLETE = 'features/Request/START_UNDO_COMPLETE';
export const ERROR_UNDO_COMPLETE = 'features/Request/ERROR_UNDO_COMPLETE';
export const DONE_UNDO_COMPLETE = 'features/Request/DONE_UNDO_COMPLETE';


export const START_DELETE_HABIT = 'featurs/Request/START_DELETE_HABIT';
export const ERROR_DELETE_HABIT = 'features/Request/ERROR_DELETE_HABIT';
export const DONE_DELETE_HABIT = 'features/Request/DONE_DELETE_HABIT';
